import { getColor } from '@webapp/common/lib/ui';

export const COLORS = [
    getColor('light-blue'),
    getColor('purple-bg'),
    getColor('purple-bg-dark'),
    '#C397F8',
    '#F08D8A',
    '#F3AA76',
    '#F7E084',
    '#B9ED88',
    '#B8FFCF',
    '#94F1E4',
];

export const COLORS_COUNT = COLORS.length;
